/* UnhandledError.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { useElementBreakpoints } from '../../hooks/useElementBreakpoints';
import { ErrorButton, ErrorButtonContainer, ErrorFloatingContainer, ErrorMessage } from './error-screen-parts';
import messages from './messages';
export var UnhandledErrorScreen = function UnhandledErrorScreen(_ref) {
  var onCancel = _ref.onCancel,
    text = _ref.text;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useElementBreakpoint = useElementBreakpoints(),
    _useElementBreakpoint2 = _slicedToArray(_useElementBreakpoint, 2),
    setBreakpointsElement = _useElementBreakpoint2[0],
    breakpoint = _useElementBreakpoint2[1].breakpoint;
  return /*#__PURE__*/React.createElement(ErrorFloatingContainer, {
    ref: setBreakpointsElement,
    breakpoint: breakpoint
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, formatMessage(messages.ariaErrorTitle)), /*#__PURE__*/React.createElement(ErrorMessage, {
    breakpoint: breakpoint
  }, text), /*#__PURE__*/React.createElement(ErrorButtonContainer, null, /*#__PURE__*/React.createElement(ErrorButton, {
    autoFocus: true,
    testId: 'cancel',
    onClick: onCancel,
    appearance: "primary"
  }, formatMessage(messages.cancelLabel))));
};